import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=7ac4cad7"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac4cad7')) {
      api.createRecord('7ac4cad7', component.options)
    } else {
      api.reload('7ac4cad7', component.options)
    }
    module.hot.accept("./ErrorModal.vue?vue&type=template&id=7ac4cad7", function () {
      api.rerender('7ac4cad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/ErrorModal.vue"
export default component.exports